export default [
    { type: 'qr', name: 'QR' },
    { type: 'credit_card', name: 'Credit Card' },
    { type: 'debit_card', name: 'Debit Card' },
];



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/setting/payment/custom/m1-payment-types.js